import { useIntl } from "react-intl";
import { ActionBar, Column, Container, Heading, Row } from "lcm-iot-commons";
import TenantForm from "./TenantForm";

export default function TenantCreate() {
  const intl = useIntl();

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading
              title={intl.formatMessage({ id: "tenant_create.header" })}
            />
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <Column>
          <TenantForm />
        </Column>
      </Row>
    </Container>
  );
}
